import { Grid, Typography } from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import React from "react";
import { assetItems } from "../../steps/objects/assetItems";

const grandSeperator = val => {
  if(!val) {
		return "0"
	}
  
  val = val
    .toString()
    .replace(/,/g, "")
    .replace(/ /g, "");
  let parsed = parseInt(val);

  if (!isNaN(parsed)) {
    return parsed.toLocaleString().replace(/,/g, " ");
  } else {
    return val;
  }
};

const customRow = (firstCol, secondCol, thirdCol) => {
  return (
    <React.Fragment>
      <Grid item xs={12} sm={12} md={12}>
        <Grid container>
          <GridItem xs={3} sm={3} md={3}>
            {firstCol}
          </GridItem>
          <GridItem xs={2} sm={2} md={2}>
            {secondCol}
          </GridItem>
          <GridItem xs={2} sm={2} md={2}>
            {thirdCol}
          </GridItem>
          <GridItem xs={5} sm={5} md={5}>
            
          </GridItem>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const CGT = props => {
  const cgt_data = props.state.result.cgt;

  return (
    <React.Fragment>
      <Grid container className="fnaGridHeading">

      <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Assets</strong>
          </Typography>
        </GridItem>

        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Description</strong>
          </Typography>
        </GridItem>

        <GridItem xs={2} sm={2} md={2}>
          <Typography variant="subheading">
            <strong>Market Value of client's share</strong>
          </Typography>
        </GridItem>
        <GridItem item xs={2} sm={2} md={2}>
          <Typography variant="subheading">
            <strong>Client's base cost</strong>
          </Typography>
        </GridItem>
        <GridItem item xs={2} sm={2} md={2}>
          <Typography variant="subheading">
            <strong>Client's Capital Gain</strong>
          </Typography>
        </GridItem>
      </Grid>
      <Grid direction="column" className="fnaGridBody">
        {cgt_data.cgtAssets.map((assetType, i) => {
          
          const assetName = assetType.description;
           
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={i % 2 === 0 ? "" : "disabledRow"}
            >
              <Grid container className="fnaGridBodyRow">
                
              <GridItem xs={3} sm={3} md={3}>
                  <Typography
                    style={{ wordWrap: "break-word", paddingTop: "5px" }}
                  >
                    {assetType.category}
                  </Typography>
                </GridItem>

                <GridItem xs={3} sm={3} md={3}>
                  <Typography
                    style={{ wordWrap: "break-word", paddingTop: "5px" }}
                  >
                    {assetName}
                  </Typography>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(assetType.marketValue.toString())}
                  </Typography>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(assetType.baseCost)}
                  </Typography>
                </GridItem>
                <GridItem xs={2} sm={2} md={2}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(assetType.capitalGain)}
                  </Typography>
                </GridItem>
              </Grid>
            </Grid>
          );
        })}
        <Grid item xs={12} sm={12} md={12} style={{}}>
          <Grid container className="fnaGridBodyRow">
            <GridItem xs={6} sm={6} md={6}>
              <Typography style={{ paddingTop: "20px" }}>
                <strong>Total</strong>
              </Typography>
            </GridItem>
            <GridItem xs={2} sm={2} md={2}>
              <Typography style={{ paddingTop: "20px" }}>
                <b>R{" "}
                {grandSeperator(
                  cgt_data.netCgtMarketValue
                )}</b>
              </Typography>
            </GridItem>
            <GridItem xs={2} sm={2} md={2}>
              <Typography style={{ paddingTop: "20px" }}>
                <b>R{" "}
                {grandSeperator(cgt_data.netClientsBaseCost)}</b>
              </Typography>
            </GridItem>
            <GridItem xs={2} sm={2} md={2}>
              <Typography style={{ paddingTop: "20px" }}>
                <b>R{" "}
                {grandSeperator(
                  cgt_data.netClientsCapitalGain
                )}</b>
              </Typography>
            </GridItem>
          </Grid>
        </Grid>
      </Grid>

      {/* ============================== Capital Gain =================================*/}
      {/* =============================================================================*/}

      <Grid
        direction="column"
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            <strong>Capital Gain: </strong>
          </Typography>,
          null,
          <Typography style={{ paddingTop: "5px" }}>
           <b> R {grandSeperator(cgt_data.netClientsCapitalGainDisplay)}</b>
          </Typography>
        )}

       
       

        {/* ================= Spouse's Roll Over =========================*/}
        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            <strong>Minus: Spouse's Roll Over</strong>
          </Typography>,
          null,
          <Typography style={{ paddingTop: "5px" }}>
            <b>R {grandSeperator(cgt_data.minusspouseRollOver.netRollOver)}</b>
          </Typography>
        )}

        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            Portion bequethed to Spouse
          </Typography>,
          <Typography style={{ paddingTop: "5px" }}>
            R{" "}
            {grandSeperator(
              cgt_data.minusspouseRollOver.portionBequethedTospouse
            )}
          </Typography>,
          null
        )}

        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            Portion to Spouse as part of residue
          </Typography>,
          <Typography style={{ paddingTop: "5px" }}>
            R{" "}
            {grandSeperator(
              cgt_data.minusspouseRollOver.portionResidueTospouse
            )}
          </Typography>,
          null
        )}

        {customRow(
          null,
          null,
          <Typography style={{ paddingTop: "5px", textDecorationLine: 'overline' }}>
            {" "}
            
              <b>R {grandSeperator(cgt_data.netMinusRollOver)}</b>
            
          </Typography>
        )}

        {/* ================= Previous Loss carried over =========================*/}
        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            <strong>Minus: Previous loss carried over</strong>
          </Typography>,
          null,
          <Typography style={{ paddingTop: "5px"  }}>
            R {grandSeperator(cgt_data.minusPreviousLoss )}
          </Typography>
        )}

        {customRow(
          null,
          null,
          <Typography style={{ paddingTop: "5px", textDecorationLine: 'overline' }}>
           
              <b>R{" "}
              {grandSeperator(
                cgt_data.netMinusPreviousLoss
              )}</b>
            
          </Typography>
        )}

        {/* ====================== Minus: Exclusion at death ====================== */}
        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            <strong>Minus: Exclusion at death</strong>
          </Typography>,
          null,
          <Typography style={{ paddingTop: "5px" }}>
            R {grandSeperator(cgt_data.minusExclusionAtDeath)}
          </Typography>
        )}

        {customRow(
         <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            <strong>Net Capital Gain</strong>
          </Typography>,
          null,
          <Typography style={{ paddingTop: "5px" , textDecorationLine: 'overline'}}>
            <b>R {grandSeperator(cgt_data.netCgt)}</b>
          </Typography>
        )}

        {/* ========================= Rates ========================= */}


        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            Inclusion rate
          </Typography>,
          <Typography style={{ paddingTop: "5px" }}>
            {cgt_data.inclusionRate}%
          </Typography>,
          null
        )}
        
        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "5px" }}>
            Marginal tax rate
          </Typography>,
          <Typography style={{ paddingTop: "5px" }}>
            {cgt_data.marginalTax}%
          </Typography>,
          null
        )}

        

        {/* ==================== CGT Payable ==================== */}
        {customRow(
          <Typography style={{ wordWrap: "break-word", paddingTop: "25px" }}>
            <strong>CGT payable</strong>
          </Typography>,
          null,
          <Typography style={{ paddingTop: "25px", textDecorationLine: 'overline' }}>
            <b>R {grandSeperator(cgt_data.cgtPayable)}</b>
          </Typography>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default CGT;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/results/CGT.jsx